import { LitEntity, html, css } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import '../common/bn-surface';
import '../a2hs/a2hs-surface';
import './actions/update-user';
import './actions/change-password';
import './props/user-name';
import './actions/user-update-preferences';

class UserShow extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      .actions {
        display: flex;
        flex-wrap: wrap;
      }
      .action {
        flex-grow: 1;
      }
      user-update-preferences[group="metrics"] {
        --form-field-width: 33.33333333333%;
        --form-display: flex;
      }
      user-update-preferences[group="notifications"] {
        --form-field-width: 50%;
        --form-display: flex;
      }
    `];
  }

  render() {
    let notificationEntity;
    let metricsEntity;
    if (this.entity) {
      notificationEntity = this.entity.getSubEntityByClasses(['preferences', 'notifications']);
      metricsEntity = this.entity.getSubEntityByClasses(['preferences', 'metrics']);
    }

    return html`
      <h1><user-name .href="${this.href}"></user-name></h1>
      <div class="actions">
        <bn-surface class="action">
          <h3>User Information</h3>
          <update-user .href="${this.href}"></update-user>
        </bn-surface>

        <bn-surface class="action">
          <h3>Change Password</h3>
          <change-password .href="${this.href}"></change-password>
        </bn-surface>

        <bn-surface class="action">
          <user-update-preferences
            .entity="${notificationEntity}"
            group="notifications"
          ></user-update-preferences>
        </bn-surface>

        <bn-surface class="action">
          <user-update-preferences
            .entity="${metricsEntity}"
            group="metrics"
          ></user-update-preferences>
        </bn-surface>
      </div>
      <a2hs-surface class="action"></a2hs-surface>
    `;
  }
}

window.customElements.define('user-show', UserShow);
